import { render, staticRenderFns } from "./bond.vue?vue&type=template&id=5a4836d6&scoped=true&"
import script from "./bond.vue?vue&type=script&lang=js&"
export * from "./bond.vue?vue&type=script&lang=js&"
import style0 from "./bond.vue?vue&type=style&index=0&id=5a4836d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4836d6",
  null
  
)

export default component.exports